import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import bannerImage from "../../Images/commonimg/blog1.jpg";
import NotFoundPage from "../../404Page";

const BlogDetails = () => {
  const { url } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Base URL for blog images if they are relative paths
  const baseUrl = `https://isbmuniversity.edu.in/admin-portal/blogs/${url}`;

  useEffect(() => {
    // Only fetch if blogId exists
    if (!url) {
      setError("Invalid blog ID.");
      setLoading(false);
      return;
    }

    console.log("Fetching blog with ID:", url); // Debug

    const fetchBlog = async () => {
      try {
        const response = await axios.get(
          `https://isbmuniversity.edu.in/admin-portal/blogs/${url}`,
        );

        console.log("API response:", response.data);

        const { success, data } = response.data;

        if (success && Array.isArray(data) && data.length > 0) {
          setBlog(data[0]);
        } else {
          setBlog(null);
          setError("Blog not found.");
        }
      } catch (err) {
        console.error("Error fetching blog:", err);
        setBlog(null);
        setError("Failed to fetch blog details.");
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [url]);

  useEffect(() => {
    if (!blog) return;

    // Title
    document.title = blog.meta_title || "Blog Details";

    // Meta Description
    let metaDesc = document.querySelector("meta[name='description']");

    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }

    metaDesc.content = blog.meta_description || "";

    // Remove existing schema first
    const existingSchemas = document.querySelectorAll(
      'script[data-schema="blog-schema"]',
    );

    existingSchemas.forEach((tag) => tag.remove());

    // Clean schema from API
    const cleanSchema = (blog.schema || "")
      .replace(/<script[^>]*>/gi, "")
      .replace(/<\/script>/gi, "")
      .trim();

    // Create fresh schema tag
    if (cleanSchema) {
      const schemaTag = document.createElement("script");
      schemaTag.type = "application/ld+json";
      schemaTag.setAttribute("data-schema", "blog-schema");
      schemaTag.text = cleanSchema;

      document.head.appendChild(schemaTag);
    }

    // Cleanup on component unmount
    return () => {
      document
        .querySelectorAll('script[data-schema="blog-schema"]')
        .forEach((tag) => tag.remove());
    };
  }, [blog]);

  if (loading) return <p className="text-center my-5">Loading...</p>;
  // if (error) return <p className="text-center text-danger my-5">{error}</p>;
  // if (!blog) return <p className="text-center my-5">No blog found.</p>;

  if (!loading && (error || !blog)) {
    return <NotFoundPage />;
  }

  return (
    <>
      <Topnav />

      {/* Banner */}
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content text-center">
              <h1>{blog?.title || "Blog Details"}</h1>
              <ol className="breadcrumb mt-3 mb-0 justify-content-center">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Blog Details
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Content */}
      <section className="container my-5">
        <div className="clearfix">
          {/* Blog Image */}
          <img
            src={
              blog.banner && blog.banner.trim() !== ""
                ? `https://isbmuniversity.edu.in/admin-server/public/uploads/blogs/${blog.banner}`
                : bannerImage
            }
            alt={blog?.title || "Blog Banner"}
            className="img-fluid rounded float-lg-end ms-lg-4 mb-3"
            style={{ maxWidth: "400px" }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = bannerImage;
            }}
          />

          {/* Blog Description (HTML content) */}
          <div dangerouslySetInnerHTML={{ __html: blog?.description || "" }} />

          {/* Blog Title & Date */}
          <div className="row">
            <p className="text-muted col-6">
              <i
                className="ti ti-calendar me-1 text-black"
                style={{ fontSize: "20px" }}
              ></i>{" "}
              {/* user/author icon */}
              {blog?.created_at
                ? new Date(blog.created_at).toLocaleDateString("en-GB")
                : "N/A"}
            </p>
            <p className="text-muted col-6 text-end">
              <i
                className="ti ti-user me-1 text-black"
                style={{ fontSize: "20px" }}
              ></i>{" "}
              {/* user/author icon */}
              {blog?.user_id ?? "N/A"}
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default BlogDetails;
